import React from "react";
import { useApp } from "../contexts/AppContext";

export default function PrivacyPage() {
  const { t } = useApp();
  const p = t.privacy || {};

  const sections = p.sections || [
    {
      h: "1. Toplanan məlumatlar",
      b: "Sayta qeydiyyatdan keçərkən və ya sifariş verərkən sizdən ad, soyad, e-poçt, telefon nömrəsi və çatdırılma ünvanı kimi məlumatlar toplanır. Ödəniş zamanı kart məlumatları yalnız tərəfdaş ödəniş provayderində emal olunur — Vinyl Baku bu məlumatları saxlamır.",
    },
    {
      h: "2. Məlumatların istifadəsi",
      b: "Topladığımız məlumatlar yalnız sifarişin emalı, çatdırılması, müştəri dəstəyi və qanuni öhdəliklərin yerinə yetirilməsi üçün istifadə olunur. İstək olmadan reklam göndərilmir.",
    },
    {
      h: "3. Çərəzlər (cookies)",
      b: "Sayt müəyyən funksiyaların — məsələn, dil seçimi, səbət və daxiletmə vəziyyəti — düzgün işləməsi üçün çərəzlərdən istifadə edir. Brauzer parametrlərindən çərəzləri istənilən vaxt deaktiv edə bilərsiniz.",
    },
    {
      h: "4. Ödənişlərin emalı (Epoint.az)",
      b: "Onlayn ödənişlər Azərbaycan Respublikasının lisenziyalı ödəniş provayderi olan Epoint.az platforması vasitəsilə həyata keçirilir. Kart məlumatlarınız (kart nömrəsi, son istifadə tarixi, CVV) birbaşa Epoint-in PCI DSS sertifikatına malik təhlükəsiz sistemində daxil edilir və emal olunur. Vinyl Baku saytı bu məlumatlara çıxış əldə etmir və onları saxlamır. Ödənişdən sonra Epoint yalnız əməliyyatın nəticəsini (uğurlu / uğursuz, məbləğ, əməliyyat ID) saytımıza ötürür.",
    },
    {
      h: "5. Üçüncü tərəflər",
      b: "Məlumatlarınız satılmır. Yalnız çatdırılma operatorları və ödəniş provayderi (Epoint.az) kimi xidməti təmin etmək üçün lazım olan tərəflərə ötürülür.",
    },
    {
      h: "6. Saxlama müddəti",
      b: "Hesab məlumatları hesab aktiv olduğu müddətdə saxlanılır. Sifariş tarixçəsi mühasibat və qanun tələbləri çərçivəsində 5 il müddətində saxlanılır.",
    },
    {
      h: "7. Sizin hüquqlarınız",
      b: "Hər zaman məlumatlarınıza baxmaq, düzəltmək və ya hesabınızı silmək tələbi göndərə bilərsiniz. Bunun üçün support@vinylbaku.az ünvanına müraciət edin.",
    },
    {
      h: "8. Əlaqə",
      b: "Məxfilik siyasəti ilə bağlı suallar üçün: support@vinylbaku.az · Bakı, Azərbaycan.",
    },
  ];

  return (
    <div className="bg-[var(--bg)]" data-testid="privacy-page">
      <section className="max-w-3xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-24">
        <div className="metadata text-[var(--text-muted)] mb-6">{p.eyebrow || "VINYL BAKU AZ"}</div>
        <h1 className="section-title text-4xl md:text-6xl leading-[1.05]">
          {p.title || "Məxfilik siyasəti"}
        </h1>
        <div className="metadata text-[var(--text-muted)] mt-6">
          {p.updated || "Son yenilənmə: 2025-cü il"}
        </div>
        <p className="text-[var(--text-2)] text-base md:text-lg leading-relaxed mt-10">
          {p.intro ||
            "Vinyl Baku olaraq şəxsi məlumatlarınızın təhlükəsizliyinə hörmətlə yanaşırıq. Bu sənəd hansı məlumatların toplandığını, necə istifadə olunduğunu və hansı hüquqlara malik olduğunuzu izah edir."}
        </p>

        <div className="mt-14 space-y-10">
          {sections.map((s, i) => (
            <div key={i} className="border-t border-[var(--border-soft)] pt-8">
              <h2 className="section-title text-2xl md:text-3xl">{s.h}</h2>
              <p className="text-[var(--text-2)] mt-3 leading-relaxed whitespace-pre-line">{s.b}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
